import { track } from "@vercel/analytics";

export function trackEvent(name, payload = {}) {
  try {
    track(name, payload);
  } catch {
    // Ignore analytics errors so product flows never break.
  }
}
